import { render, staticRenderFns } from "./TitleDescription.vue?vue&type=template&id=f97a3c6e"
import script from "./TitleDescription.vue?vue&type=script&lang=js"
export * from "./TitleDescription.vue?vue&type=script&lang=js"
import style0 from "./TitleDescription.vue?vue&type=style&index=0&id=f97a3c6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports